<template>
  <div class="">
    <wh-field-select-popup v-model="cameraId" label="选择摄像头" :columns="cameraOptions" @change="getCameraDetails" />
    <div class="video-frame">
      <iframe v-if="cameraId&&cameraDetails&&cameraDetails.status===1" :src="cameraUrl" allow="fullscreen" />
      <video v-else :src="cameraUrl" autoplay loop muted style="width: 100%;height: 500px;" />
      <!--      <div v-else class="no-camera" />-->
    </div>
    <div v-if="cameraId" class="control-box">
      <div class="scale-control">
        <!--        <div
          class="control-item"
          @click="ptzControl(8, controlOptions.speed)"
        >
          <svg-icon icon-class="zoom-in" />
        </div>
        <div
          class="control-item"
          @click="ptzControl(9, controlOptions.speed)"
        >
          <svg-icon icon-class="zoom-out" />
        </div>-->
        <div class="control-item" @click="ptzControl(15)">
          <van-icon name="replay" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WhFieldSelectPopup from '@/components/wh-field-select-popup/wh-field-select-popup'
import api from '@/api'
import axios from 'axios'
export default {
  name: 'Index',
  components: { WhFieldSelectPopup },
  data() {
    return {
      cameraOptions: [],
      cameraId: '',
      cameraDetails: undefined,
      cameraUrl: undefined,
      controlOptions: {
        speed: 1
      }
    }
  },
  created() {
    this.getCameraList()
  },
  methods: {
    getCameraList() {
      if (this.$store.getters.userData.secretKey) {
        api.getCameraList().then(({ data }) => {
          this.cameraOptions = data.list.map(i => {
            return { text: i.cameraName, value: i.id }
          })
          if (this.cameraOptions.length) {
            this.cameraId = this.cameraOptions[0].value
            this.getCameraDetails()
          }
        })
      } else {
        this.$toast('暂无摄像头相关数据!')
      }
    },
    getCameraDetails() {
      this.cameraDetails = undefined
      this.cameraUrl = undefined
      api.getCameraDetails({ id: this.cameraId }).then(({ data, msg }) => {
        if (data) {
          this.cameraDetails = data.cameraInfo
          if (this.cameraDetails.status !== 1) {
            const dict = { 'J92884730': 'https://cdntrace.whhda.xyz/J92884730.MP4', 'J94285895': 'https://cdntrace.whhda.xyz/J94285895.MP4', 'J94285933': 'https://cdntrace.whhda.xyz/J94285933.MP4', 'J94285896': 'https://cdntrace.whhda.xyz/J94285896.MP4', 'J94285954': 'https://cdntrace.whhda.xyz/J94285954.MP4' }
            this.cameraUrl = dict[this.cameraDetails.deviceSerial]
          } else {
            // this.cameraUrl = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://${this.cameraDetails.validateCode}@open.ys7.com/${this.cameraDetails.deviceSerial}/1.live&autoplay=1&accessToken=${this.cameraDetails.accessToken}&templete=1`
            // this.cameraUrl = `https://open.ys7.com/ezopen/h5/live?autoplay=1&accessToken=${this.cameraDetails.accessToken}&validCode=${this.cameraDetails.validateCode}&deviceSerial=${this.cameraDetails.deviceSerial}&channelNo=1`
            this.cameraUrl = `https://open.ys7.com/jssdk/theme/h5/live.html?deviceSerial=${this.cameraDetails.deviceSerial}&channelNo=1&accessToken=${this.cameraDetails.accessToken}&validCode=${this.cameraDetails.validateCode}`
          }
        } else {
          this.$toast(msg)
        }
      })
    },
    ptzControl(direction, speed) {
      if (!this.cameraId) return
      const bodyFormData = new FormData()
      bodyFormData.append('accessToken', this.cameraDetails.accessToken)
      bodyFormData.append('deviceSerial', this.cameraDetails.deviceSerial)
      bodyFormData.append('channelNo', this.cameraDetails.channelNo)
      if (direction === 15) {
        bodyFormData.append('index', 1)
      } else {
        bodyFormData.append('direction', direction)
        bodyFormData.append('speed', speed)
      }
      axios({
        method: 'post',
        url: direction === 15 ? 'https://open.ys7.com/api/lapp/device/preset/move' : 'https://open.ys7.com/api/lapp/device/ptz/start',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        data: bodyFormData
      }).then(response => {
        if (response.data.code !== '200') {
          this.$toast(response.data.msg)
        } else {
          if (direction !== 15) {
            setTimeout(() => {
              this.ptzStopControl(direction, 0)
            }, 800)
          }
        }
      })
    },
    ptzStopControl(direction, speed) {
      const bodyFormData = new FormData()
      bodyFormData.append('accessToken', this.cameraDetails.accessToken)
      bodyFormData.append('deviceSerial', this.cameraDetails.deviceSerial)
      bodyFormData.append('channelNo', this.cameraDetails.channelNo)
      if (direction === 15) {
        bodyFormData.append('index', 1)
      } else {
        bodyFormData.append('direction', direction)
        bodyFormData.append('speed', speed)
      }
      axios({
        method: 'post',
        url: direction === 15 ? 'https://open.ys7.com/api/lapp/device/preset/move' : 'https://open.ys7.com/api/lapp/device/ptz/start',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        data: bodyFormData
      }).then(response => {
        if (response.data.code !== '200') {
          this.$toast(response.data.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.video-frame {
  position: relative;
  height: 700px;
  .no-camera {
    width: 100%;
    height: 700px;
    background: url("~@/assets/images/Iot/no-camera.png") center no-repeat;
  }
  iframe {
    width: 100%;
    height: 700px;
  }
}
.control-box {
  user-select: none;
  padding: 10px;
  background: #fff;
  .control-item {
    vertical-align: top;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: 1px solid #eee;
    border-radius: 3px;
    cursor: pointer;
    transition: all .1s linear;
    user-select: none;
  }
  .scale-control {
    text-align: center;
    > div {
      margin: 0 10px;
    }
  }
}
</style>
